import { Dialog } from 'primereact/dialog';
import React, { useState } from 'react';

import { CaMangerTl } from '../../../features/correctiveActions/managerTlViewSearch/CaMangerTlView';
import { MyDashboardCa } from '../../correctiveActions/myDashboardCa/myDashboardCa';

type MyCaDashboardScorecardProps = {
    view?: boolean;
};

export const MyCaDashboardScorecard = ({ view = false }: MyCaDashboardScorecardProps) => {
    const [visible, setVisible] = useState(false);
    const [selectedEmployee, setSelectedEmployee] = useState<any>();

    const hideDialog = () => {
        setVisible(false);
    };
    const handleSelectedEmployee = (arg: any) => {
        setSelectedEmployee(arg);
        setVisible(true);
    };
    return (
        <>
            <MyDashboardCa fromPage="scorecardDashboard" setSelectedEmployee={handleSelectedEmployee} />
            <Dialog
                header="Corrective Action Details"
                visible={visible}
                style={{ width: '80vw' }}
                onHide={hideDialog}
                modal
            >
                <CaMangerTl
                    handleCloseDialog={hideDialog}
                    type={'ack'}
                    getDetails
                    via={'scorecardDashboard'}
                    selectedEmployee={selectedEmployee}
                    view={view}
                />
            </Dialog>
        </>
    );
};
